import { Field, useFormikContext } from 'formik'
import cn from 'classnames'
import Fuse from 'fuse.js'
import { isEmpty } from 'lodash'

import TextBox from 'components/TextBox'
import NumberBox from 'components/NumberBox'
import ToggleButton from 'components/ToggleButton'

import { venueSettingsItems } from 'resources'
import { FUSE_OPTIONS } from 'utils/fuseSettings'

const VenueSettings = ({ searchQuery }) => {
  const { setFieldValue, values } = useFormikContext()

  const filteredVenueSettingaItems = isEmpty(searchQuery)
    ? venueSettingsItems
    : new Fuse(venueSettingsItems, FUSE_OPTIONS)
        .search(searchQuery)
        .map((item) => item.item)

  return (
    <section className="venue-settings">
      {filteredVenueSettingaItems.map(
        ({ title, description, name, type }) => {
          return (
            <article key={title} className="venue-settings__setting">
              <div className="venue-settings__text">
                <header>
                  <h5 className="venue-settings__title">{title}</h5>
                </header>
                <p className="venue-settings__description">
                  {description}
                </p>
              </div>
              <div
                className={cn('venue-settings__input', `-${type}`)}
              >
                {type === 'number' && (
                  <NumberBox
                    name={name}
                    value={values[name]}
                    min="0"
                    onChangeAdd={() => {
                      setFieldValue(name, Number(values[name]) + 1)
                    }}
                    onChangeMinus={() => {
                      if (values[name] === 0) {
                        return
                      }

                      setFieldValue(name, Number(values[name]) - 1)
                    }}
                    onChange={(e) =>
                      setFieldValue(name, e.target.value)
                    }
                  />
                )}
                {type === 'checkbox' && (
                  <Field component={ToggleButton} name={name} />
                )}
                {type === 'text' && (
                  <Field component={TextBox} masked name={name} />
                )}
              </div>
            </article>
          )
        }
      )}
    </section>
  )
}

export default VenueSettings
